import _ from 'lodash';
import async from 'async';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

//import { validateEmail } from '../../libs/utility';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';
import ActivatingDeliveryDialog from './ActivatingDeliveryDialog';
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	sectionHeader : {
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
		marginTop : 30,
		marginBottom : 10,
	},
	flow : {
		color : '#666',
	},
	supplierCheck : {
		paddingBottom : 10,
		color : '#666',
	},
	testBody : {
		border : '1px solid #ddd',
		padding : 10,
	},
	bodyPre : {
		whiteSpace: 'pre-wrap',
	},
	dialogPaper : {
		maxWidth : 1000,
		overflow: 'scroll',
	},
	row : {
		cursor : 'pointer',
	},
	button: {
		verticalAlign : 'middle',
		padding : '8px 10px',
	},
	submitButton : {
		fontSize : 18,
		borderRadius : '100px',
		padding : '20px 30px',
		textTransform: 'uppercase'
	},
	addInputButton : {
		borderRadius : '100px',
		marginTop : 20,
	},
	changesContainer : {
		backgroundColor: '#E3F2FD',
		marginBottom: 15,
		padding: 15,
		border: '1px solid #BADEFB',
	}
});

class ConfirmBulkDeliveryBatchDialog extends Component {
	constructor (props) {
		super(props);
		this.state = {
			isActiveDialogOpen: false,
			activatingStatus: 'pending',
		};
	}

	handleClose = () => {
		this.props.onClose();
	};

	handleUpdate = () => {
		const {
			updateBulkDelivery,
			updateParams,
			//showErrors,
		} = this.props;

		this.setState({
			isActiveDialogOpen: true,
			activatingStatus: 'activating'
		});

		setTimeout(() => {
			async.waterfall([
				callback => {
					updateBulkDelivery({
						params: updateParams,
						callback
					});
				}
			], err => {
				//- error popup is already shown
				if (err) { console.error('There was an error'); }
				this.setState({activatingStatus: 'done'});
			});
		}, 2000);
	};

	closeActivatingDialog = () => {
		this.setState({isActiveDialogOpen: false});
	};

	render () {
		const {classes, changeResult, fullScreen } = this.props;
		if (!changeResult) { return null; }
		const { changes, hasCarrierChange, hasSupplierChange} = changeResult;
		if (!changes) { return null; }

		const {isActiveDialogOpen, activatingStatus} = this.state;
		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth='md'
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper
				}}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						Verify and Update Bulk Delivery
					</DialogTitle>
					<DialogContent>
						<div
							className={classes.sectionHeader}
							style={{marginTop: 5}}
						>
							Changes
						</div>
						<div className={classes.changesContainer}>
							<ul style={{padding: 10, margin: 0}}>
								{changes.map((change, i) => {
									return (<li key={i}>{change.display}.</li>);
								})}
							</ul>
						</div>

						{hasCarrierChange &&
						<div className={classes.changesContainer}>
							NOTE : Carrier has changed so old carrier will get a cancellation email.
						</div>
						}

						{hasSupplierChange &&
						<div className={classes.changesContainer}>
							NOTE : Supplier has changed so old supplier will get a cancellation email.
						</div>
						}

					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>
							Cancel
						</Button>
						<Button
							disabled={isActiveDialogOpen}
							variant="contained"
							onClick={this.handleUpdate}
							className={classes.submitButton}
							color="primary"
						>
							Update Bulk Delivery
						</Button>
					</DialogActions>
				</div>

				<ActivatingDeliveryDialog
					open={isActiveDialogOpen}
					onClose={this.closeActivatingDialog}
					status={activatingStatus}
				/>

			</Dialog>
		);
	}
}

ConfirmBulkDeliveryBatchDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,

	updateBulkDelivery : PropTypes.func.isRequired,
	bulkDelivery : PropTypes.object,
	changeResult : PropTypes.object,
	updateParams : PropTypes.object,

	classes: PropTypes.object.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	showErrors : PropTypes.func,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(ConfirmBulkDeliveryBatchDialog);